"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { useEffect, useRef, useState } from "react";
import { useI18n } from "@llmgateway/i18n/react";
import { selectEnterpriseText } from "./i18n";
interface CalendlyApi {
  initInlineWidget: (options: {
    url: string;
    parentElement: HTMLElement;
    prefill?: {
      name?: string;
      email?: string;
    };
  }) => void;
}
declare global {
  interface Window {
    Calendly?: CalendlyApi;
  }
}
export function CalendlyInline(t0) {
  const $ = _c(17);
  const {
    url,
    name,
    email
  } = t0;
  const {
    locale
  } = useI18n();
  let t1;
  if ($[0] !== locale) {
    t1 = selectEnterpriseText(locale);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const text = t1.contact.calendly;
  const containerRef = useRef(null);
  const initializedRef = useRef(false);
  const [scriptLoaded, setScriptLoaded] = useState(typeof window !== "undefined" && Boolean(window.Calendly));
  let t2;
  let t3;
  if ($[2] !== email || $[3] !== name || $[4] !== scriptLoaded || $[5] !== url) {
    t2 = () => {
      const container = containerRef.current;
      if (!scriptLoaded || !container || !window.Calendly || initializedRef.current) {
        return;
      }
      initializedRef.current = true;
      const widgetUrl = new URL(url);
      widgetUrl.searchParams.set("hide_gdpr_banner", "1");
      widgetUrl.searchParams.set("primary_color", "2563eb");
      if (document.documentElement.classList.contains("dark")) {
        widgetUrl.searchParams.set("background_color", "0a0a0a");
        widgetUrl.searchParams.set("text_color", "e4e4e7");
      }
      window.Calendly.initInlineWidget({
        url: widgetUrl.toString(),
        parentElement: container,
        prefill: {
          name,
          email
        }
      });
    };
    t3 = [scriptLoaded, url, name, email];
    $[2] = email;
    $[3] = name;
    $[4] = scriptLoaded;
    $[5] = url;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <link rel="stylesheet" href="https://assets.calendly.com/assets/external/widget.css" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Script src="https://assets.calendly.com/assets/external/widget.js" strategy="afterInteractive" onLoad={() => setScriptLoaded(true)} />;
    t6 = <div ref={containerRef} className="h-[1040px] w-full overflow-hidden rounded-xl border border-border bg-card sm:h-[720px]" />;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[11] !== text.openScheduler || $[12] !== url) {
    t7 = <a href={url} target="_blank" rel="noopener noreferrer" className="font-medium text-blue-600 underline-offset-4 hover:underline dark:text-blue-400">{text.openScheduler}</a>;
    $[11] = text.openScheduler;
    $[12] = url;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7 || $[15] !== text.preferNewTab) {
    t8 = <>{t4}{t5}{t6}<p className="mt-3 text-center text-sm text-muted-foreground">{text.preferNewTab}{" "}{t7}</p></>;
    $[14] = t7;
    $[15] = text.preferNewTab;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}